export default "__VITE_ASSET__1K0V031icE1orVqM8sp_9A__"